/* eslint-disable */
import { useEffect, useRef, useState } from "react";
import { Box, Button, Card, Container, Grid, Typography, useMediaQuery, Dialog } from "@mui/material";
import ContentScoreHeader from "./ContentScoreHeader";
import MainLoader from "../MainLoader/MainLoader";
import { DataGrid } from "@mui/x-data-grid";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { style, useTheme } from "@mui/system";
import { createContentquery, getContentQueriesByUserId } from "../../gql/mutations/scrapy";
import { UPDATE_CONTENT_QUERY_STATUS, DELETE_CONTENT_QUERY } from "../../gql/mutations/scrapy"; // new mutation import for delete and update status
import { UPDATE_PROJECT_SETTINGS } from "../../gql/mutations/scrapy";
import { BoxMainWrapper, SectionWrapper } from "./css";
import { useMutation, useQuery } from "@apollo/client";
// import EditNoteSharpIcon from "@mui/icons-material/EditNoteSharp";
// import RefreshSharpIcon from "@mui/icons-material/RefreshSharp";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { usePopup } from "../../context/commonPop";
import { useLocation } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SearchIcon from "@mui/icons-material/Search";

function ContentScore() {
  const isMblBreakpoint = useMediaQuery("(max-width: 820px)");
  const [widthLoader, setWidthLoader] = useState(false);
  const { sessionId } = useParams();
  const customizer = useSelector(state => state.customizer);
  const [CREATE_CONTENT_QUERY] = useMutation(createContentquery);
  const [DELETE_CONTENT] = useMutation(DELETE_CONTENT_QUERY); // new mutation hook for delete
  const [UPDATE_PROJECT_SETTINGS_MUTATION] = useMutation(UPDATE_PROJECT_SETTINGS);
  const theme = useTheme();
  const navigate = useNavigate();
  const { handleOpen } = usePopup();
  const [selected, setSelected] = useState("All");
  const filterButton = ["In Progress", "Done", "Deleted", "All"];
  const [UPDATE_STATUS] = useMutation(UPDATE_CONTENT_QUERY_STATUS); // added update status mutation hook
  const [rowCount, setRowCount] = useState(undefined);
  const [openConfirm, setOpenConfirm] = useState(false); // for delete confirmation dialog
  const [rowToDelete, setRowToDelete] = useState(null);
  const wrapperRef = useRef(null);
  const [wrapperWidth, setWrapperWidth] = useState(0);
  // const [widthLoader, setWidthLoader] = useState(false);

  const {
    data,
    loading: scrapLoading,
    error,
  } = useQuery(getContentQueriesByUserId, {
    fetchPolicy: "no-cache", // No cache read or write, always fresh!
  });
  const [contentQueries, setContentQueries] = useState(null); //contentQueries initially = undefined, so for one render cycle so make it null for initial value.
  const location = useLocation(); // to check for navigation state
  const [openSuccess, setOpenSuccess] = useState(false); // success popup state
  const [openDeleteSuccess, setOpenDeleteSuccess] = useState(false); // delete success popup state
  const [searchText, setSearchText] = useState("");
  const [openSettingsSuccess, setOpenSettingsSuccess] = useState(false);

  // SETTINGS DIALOG STATE
  const [openSettings, setOpenSettings] = useState(false);
  const [activeRow, setActiveRow] = useState(null);

  // SETTINGS FORM STATE
  const [projectMode, setProjectMode] = useState("nodomain");
  // "domain" | "nodomain"

  const [projectHomepage, setProjectHomepage] = useState("");
  const [projectName, setProjectName] = useState("");

  useEffect(() => {
    if (location.state?.showSuccessPopup) {
      setOpenSuccess(true);

      // clear router state safely
      navigate(location.pathname, { replace: true });
    }
  }, [location, navigate]);


  useEffect(() => {
    if (error) {
      console.error("Query error:", error);
      setRowCount(0);
      setContentQueries([]);
      return;
    }
    if (data?.getContentQueriesByUserId) {
      const payload = data.getContentQueriesByUserId;
      const arr = payload.map(item => ({
        id: item._id,
        contentWriterQuery: item.queryName,
        words: item.wordsCount,
        contentScore: item.content_score,
        contentCompetition: item.content_competition,
        status: item.status,
        projectMode: item.projectMode ?? "nodomain",
        projectHomepage: item.projectHomepage ?? "",
        projectName: item.projectName ?? "",
      }));
      setContentQueries(arr);
      setRowCount(arr.length);
    }
  }, [data, error]);

  // const wrapperRef = useRef(null);
  // const [wrapperWidth, setWrapperWidth] = useState(0);
  // useEffect(() => {
  //   const handleResize = entries => {
  //     for (let entry of entries) {
  //       setWidthLoader(true);
  //       setWrapperWidth(entry.contentRect.width);
  //       setTimeout(() => {
  //         setWidthLoader(false);
  //       }, 300);
  //     }
  //   };
  //   const observer = new ResizeObserver(handleResize);
  //   if (wrapperRef.current) {
  //     observer.observe(wrapperRef.current);
  //   }
  //   return () => {
  //     if (wrapperRef.current) {
  //       observer.unobserve(wrapperRef.current);
  //     }
  //   };
  // }, [wrapperRef]);
  useEffect(() => {
    if (!wrapperRef.current) return;

    const observer = new ResizeObserver(entries => {
      const entry = entries[0];
      if (!entry) return;

      setWidthLoader(true);
      setWrapperWidth(entry.contentRect.width);

      const timer = setTimeout(() => {
        setWidthLoader(false);
      }, 250);

      return () => clearTimeout(timer);
    });

    observer.observe(wrapperRef.current);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (projectMode === "nodomain") {
      setProjectHomepage("");
    } else {
      setProjectName("");
    }
  }, [projectMode]);

  // useEffect(() => {
  //   setWidthLoader(!widthLoader);
  // }, [customizer?.isCollapse]);
  useEffect(() => {
    setWidthLoader(true);
    const timer = setTimeout(() => setWidthLoader(false), 300);
    return () => clearTimeout(timer);
  }, [customizer?.isCollapse]);


  const statusColorMap = { // added status color map
    Done: "#0ea516ff",        // green
    done: "#0ea516ff",

    "In Progress": "#c1b513", // yellow
    inprogress: "#c1b513",

    Deleted: "#ff0000",     // red
    deleted: "#ff0000",
  };


  const columns = [
    {
      field: "contentWriterQuery",
      headerName: "Content writer query",
      width: 200,
      align: "left",
      headerAlign: "center",
      sortable: false,
      filterable: false,
      flex: isMblBreakpoint ? 0 : 1,
      renderCell: params => (
        <Button
          onClick={() => {
            navigate(`/content-edit/${params.row.id}`);
          }}
          title={params.row.contentWriterQuery}
          sx={{
            fontSize: "14px",
            fontWeight: "600",
            backgroundColor: "transparent",
            justifyContent: "flex-start",
            maxWidth: "250px",
            overflow: "hidden",
            "&:hover": {
              backgroundColor: theme.palette.primary.main,
            },
            "& p": {
              width: "100%",
              textOverflow: "ellipsis",
              overflow: "hidden",
            },
          }}
        >
          <Typography component="p">{params.row.contentWriterQuery}</Typography>
        </Button>
      ),
    },
    {
      field: "contentScore",
      headerName: "Content score",
      width: 150,
      align: "center",
      headerAlign: "center",
      sortable: false,
      filterable: false,
      renderCell: params => (
        <Typography
          component="span"
          sx={{
            backgroundColor: "#3674e7ff",
            color: "#ffffff",
            lineHeight: 1,
            fontSize: "14px",
            fontWeight: 600,
            borderRadius: "4px",
            minWidth: "36px",
            minHeight: "20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {params.row.contentScore}
        </Typography>
      ),
    },
    {
      field: "words",
      headerName: "Words",
      width: 150,
      align: "center",
      headerAlign: "center",
      sortable: false,
      filterable: false,
      renderCell: params => (
        <Typography
          component="span"
          sx={{
            backgroundColor: "#3674e7ff",
            color: "#ffffff",
            lineHeight: 1,
            fontSize: "14px",
            fontWeight: 600,
            borderRadius: "4px",
            minWidth: "36px",
            minHeight: "20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {params.row.words}
        </Typography>
      ),
    },
    {
      field: "contentCompetition",
      headerName: "Content Competition",
      width: 200,
      align: "center",
      headerAlign: "center",
      sortable: false,
      filterable: false,
      renderCell: params => (
        <Typography
          component="span"
          sx={{
            backgroundColor: "#3674e7ff",
            color: "#ffffff",
            lineHeight: 1,
            fontSize: "14px",
            fontWeight: 600,
            borderRadius: "4px",
            minWidth: "36px",
            minHeight: "20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {params.row.contentCompetition}
        </Typography>
      ),
    },
    {
      field: "Status", // added for status display
      headerName: "Status",
      width: 150,
      align: "center",
      headerAlign: "center",
      sortable: false,
      filterable: false,
      renderCell: params => {
        const status = params.row.status;
        const bgColor = statusColorMap[status] || "#9e9e9e";
        return (
          <Typography
            component="span"
            sx={{
              padding: "3px 6px 4px",
              backgroundColor: bgColor,
              color: "#ffffff",
              lineHeight: 1,
              fontSize: "14px",
              fontWeight: 600,
              borderRadius: "4px",
              minWidth: "36px",
              minHeight: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {params.row.status}
          </Typography>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      width: 150,
      align: "left",
      headerAlign: "center",
      align: "center",
      renderCell: params => {
        const isDeleted = params.row.status?.toLowerCase() === "deleted"; // gets the boolean value if status is deleted or not

        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
              "& button": {
                minWidth: 0,
                padding: 0,
                backgroundColor: "transparent",
                color: theme.palette.primary.main,
                "&:hover": {
                  backgroundColor: "transparent",
                  color: theme.palette.primary.light,
                },
              },
              "& svg": {
                fontSize: "22px",
              },
            }}
          >
            {/* <Button onClick={() => console.log("Edit", params.row)}>
            <EditNoteSharpIcon />
          </Button>
          <Button onClick={() => console.log("Refresh", params.row)}>
            <RefreshSharpIcon />
          </Button> */}
            {/* <Button onClick={() => handleDelete(params.row)}>
            <DeleteOutlineSharpIcon />
          </Button> */}
            {/* <Button // newly added delete button with confirmation dialog
              onClick={() => {
                setRowToDelete(params.row);
                setOpenConfirm(true); // open confirmation dialog
              }}
              // disabled={isDeleted} // disable button if already deleted
            >
              <DeleteOutlineSharpIcon />
            </Button> */}
            <Button
              onClick={() => {
                const status = params.row.status?.toLowerCase();

                if (status === "deleted") {
                  // permanent delete confirmation
                  setRowToDelete(params.row);
                  setOpenConfirm(true);
                } else {
                  // soft delete directly
                  handleSoftDelete(params.row);
                }
              }}
            >
              <DeleteOutlineSharpIcon />
            </Button>
            {/* <Button
              onClick={() => {
                setActiveRow(params.row);   // store row info
                setOpenSettings(true);      // open dialog
              }}
            >
              <SettingsOutlinedIcon />
            </Button> */}
            <Button
              onClick={() => {
                setActiveRow(params.row);

                setProjectMode(params.row.projectMode ?? "nodomain");
                setProjectHomepage(params.row.projectHomepage ?? "");
                setProjectName(params.row.projectName ?? "");

                setOpenSettings(true);
              }}
            >
              <SettingsOutlinedIcon />
            </Button>
          </Box >
        );
      },
    },
  ];
  const createQuery = async (queryName) => {
    await CREATE_CONTENT_QUERY({
      variables: { queryName },
      onCompleted: data => {
        navigate(`/content-edit/${data?.createContentQuery?._id}`);
      },
      onError: errdata => {
        handleOpen(true, "Something went wrong please wait some time");
      },
    });
  };

  // const handleDelete = async (row) => {
  //   try {
  //     await UPDATE_STATUS({
  //       variables: {
  //         queryId: row.id,
  //         status: "Deleted",
  //       },
  //     });

  //     // Optimistic UI update
  //     setContentQueries(prev =>
  //       prev.map(item =>
  //         item.id === row.id
  //           ? { ...item, status: "Deleted" }
  //           : item
  //       )
  //     );

  //     // SHOW DELETE SUCCESS POPUP
  //     setOpenDeleteSuccess(true);

  //   } catch (err) {
  //     console.error(err);
  //     handleOpen(true, "Failed to delete content");
  //   }
  // };

  const handleSoftDelete = async (row) => { // new function for soft delete
    try {
      await UPDATE_STATUS({
        variables: {
          queryId: row.id,
          status: "Deleted",
        },
      });

      // Optimistic UI update
      setContentQueries(prev =>
        prev.map(item =>
          item.id === row.id ? { ...item, status: "Deleted" } : item
        )
      );

      setOpenDeleteSuccess(true);
    } catch (err) {
      console.error(err);
      handleOpen(true, "Failed to delete content");
    }
  };

  const handlePermanentDelete = async (row) => { // new function for permanent delete
    try {
      await DELETE_CONTENT({
        variables: {
          queryId: row.id,
        },
      });

      // Remove row from UI
      setContentQueries(prev =>
        prev.filter(item => item.id !== row.id)
      );

      setRowCount(prev => prev - 1);
      setOpenDeleteSuccess(true);
    } catch (err) {
      console.error(err);
      handleOpen(true, "Failed to permanently delete blog");
    }
  };

  // const filteredQueries = selected === "All" // added filtering functionality
  //   ? contentQueries
  //   : contentQueries.filter(item => {
  //     if (selected === "In Progress") return item.status === "inprogress" || item.status === "In Progress";
  //     if (selected === "Done") return item.status === "done" || item.status === "Done";
  //     if (selected === "Deleted") return item.status === "deleted" || item.status === "Deleted";
  //     return true;
  //   });

  const filteredQueries = contentQueries // filter logic with search feature
    ?.filter(item => {
      // STATUS FILTER
      if (selected === "In Progress") {
        return item.status === "inprogress" || item.status === "In Progress";
      }
      if (selected === "Done") {
        return item.status === "done" || item.status === "Done";
      }
      if (selected === "Deleted") {
        return item.status === "deleted" || item.status === "Deleted";
      }
      return true; // All
    })
    ?.filter(item => {
      // SEARCH FILTER
      if (!searchText) return true;
      return item.contentWriterQuery
        ?.toLowerCase()
        .includes(searchText.toLowerCase());
    });

  const isSaveDisabled =
    projectMode === "domain" && !projectHomepage.trim();

  return (
    <SectionWrapper>
      <Container maxWidth={false}>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2} mt={0}>
            <Grid item xs={12}>
              <Box ref={wrapperRef} sx={{ width: "100%" }}>
                <ContentScoreHeader createQuery={createQuery} />
              </Box>
            </Grid>
          </Grid>

          <Grid container spacing={2} mt={0} sx={{ justifyContent: "center" }}>
            <Grid item xs={12}>

              {/* Show loader ONLY when loading */}
              {scrapLoading || contentQueries === null ? (
                <Box
                  sx={{
                    minHeight: "60vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <MainLoader message="Loading..." />
                </Box>
              ) : (
                <>
                  {/* Show Filter Buttons Only When Data Exists */}
                  {contentQueries && contentQueries.length > 0 && (
                    <Card
                      className="TableHeadWrapper"
                      sx={{
                        padding: "16px",
                        border: `1px solid ${theme.palette.divider}`,
                        borderBottom: "none",
                        boxShadow: "none !important",
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0,
                      }}
                    >
                      <Box className="BtnWrapper">
                        {filterButton.map(btn => (
                          <Button
                            key={btn}
                            onClick={() => setSelected(btn)}
                            className={selected === btn ? "Active" : ""}
                          >
                            {btn}
                          </Button>
                        ))}
                      </Box>
                      {/* SEARCH INPUT */}
                      <Box
                        sx={{
                          minWidth: "100px",
                          position: "relative",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {/* Search Icon */}
                        <SearchIcon
                          sx={{
                            position: "absolute",
                            left: 10,
                            color: theme.palette.text.secondary,
                            fontSize: 20,
                            pointerEvents: "none",
                          }}
                        />

                        {/* Search Input */}
                        <input
                          type="text"
                          placeholder="Search content..."
                          value={searchText}
                          onChange={(e) => setSearchText(e.target.value)}
                          style={{
                            width: "100%",
                            padding: "10px 12px 10px 36px", // LEFT padding for icon
                            borderRadius: "6px",
                            border: `1px solid ${theme.palette.divider}`,
                            fontSize: "14px",
                            outline: "none",
                          }}
                          onFocus={(e) => {
                            e.target.style.border = `1.5px solid ${theme.palette.primary.main}`;
                          }}
                          onBlur={(e) => {
                            e.target.style.border = `1px solid ${theme.palette.divider}`;
                          }}
                        />
                      </Box>
                    </Card>
                  )}

                  <BoxMainWrapper>
                    {/* CASE 1: Data Exists */}
                    {contentQueries && contentQueries.length > 0 ? (
                      widthLoader ? (
                        <MainLoader message="Loading..." />
                      ) : (
                        <Box
                          className="DataGridWrapper"
                          style={{ height: "auto", width: wrapperWidth }}
                        >
                          <DataGrid
                            rows={filteredQueries}
                            columns={columns}
                            pagination={false}
                            rowCount={rowCount}
                            loading={scrapLoading}
                            getRowId={(row) => row.id || row.url}
                            disableColumnMenu
                            hideFooter
                            className="DataTableWrapper"
                          />
                        </Box>
                      )
                    ) : (
                      /* CASE 2: No Data */
                      <Box
                        className="NotFoundWrapper"
                        sx={{ textAlign: "center", mt: 4 }}
                      >
                        <Typography component="h5">
                          No Projects Found!
                        </Typography>
                      </Box>
                    )}
                  </BoxMainWrapper>
                </>
              )}
            </Grid>
          </Grid>
          <Dialog
            open={openConfirm}
            onClose={() => setOpenConfirm(false)}
            maxWidth="xs"
            fullWidth
          >
            <Box sx={{ p: 3, textAlign: "center" }}>
              <Typography variant="h6" fontWeight={600}>
                Important
              </Typography>

              {/* <Typography sx={{ mt: 1 }}>
                Are you sure you want to permanently delete this blog?
              </Typography> */}
              {/* Updated message based on status */}
              <Typography sx={{ mt: 1 }}>
                {rowToDelete?.status?.toLowerCase() === "deleted"
                  ? "Are you sure you want to permanently delete this blog?"
                  : "Are you sure you want to delete this blog?"}
              </Typography>


              <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 3 }}>
                {/* <Button
                  variant="contained"
                  color="primary"
                  onClick={async () => {
                    if (rowToDelete) {
                      await handleDelete(rowToDelete);
                    }
                    setOpenConfirm(false);
                    setRowToDelete(null);
                  }}
                >
                  Delete
                </Button> */}

                {/* Updated button text and action based on status */}
                <Button
                  variant="contained"
                  color="error"
                  onClick={async () => {
                    if (rowToDelete) {
                      await handlePermanentDelete(rowToDelete);
                    }
                    setOpenConfirm(false);
                    setRowToDelete(null);
                  }}
                >
                  {rowToDelete?.status?.toLowerCase() === "deleted"
                    ? "Permanently Delete"
                    : "Delete"}
                </Button>


                <Button
                  variant="outlined"
                  onClick={() => {
                    setOpenConfirm(false);
                    setRowToDelete(null);
                  }}
                >
                  Cancel
                </Button>
              </Box>
            </Box>
          </Dialog>

          <Dialog
            open={openDeleteSuccess}
            onClose={() => setOpenDeleteSuccess(false)}
            maxWidth="xs"
            fullWidth
          >
            <Box sx={{ p: 3, textAlign: "center" }}>
              <CheckCircleIcon sx={{ fontSize: 48, color: "green" }} />

              <Typography variant="h6" fontWeight={600} sx={{ mt: 2 }}>
                Success
              </Typography>

              <Typography sx={{ mt: 1 }}>
                Blog deleted successfully
              </Typography>

              <Box sx={{ mt: 3 }}>
                <Button
                  variant="contained"
                  onClick={() => setOpenDeleteSuccess(false)}
                >
                  OK
                </Button>
              </Box>
            </Box>
          </Dialog>

          <Dialog open={openSuccess} onClose={() => setOpenSuccess(false)} maxWidth="xs" fullWidth>
            <Box sx={{ p: 3, textAlign: "center" }}>
              <CheckCircleIcon sx={{ fontSize: 48, color: "green" }} />

              <Typography variant="h6" fontWeight={600} sx={{ mt: 2 }}>
                Success
              </Typography>

              <Typography sx={{ mt: 1 }}>
                Content saved successfully
              </Typography>

              <Box sx={{ mt: 3 }}>
                <Button variant="contained" onClick={() => setOpenSuccess(false)}>
                  OK
                </Button>
              </Box>
            </Box>
          </Dialog>

          <Dialog
            open={openSettings}
            onClose={() => setOpenSettings(false)}
            maxWidth="sm"
            fullWidth
          >
            <Box sx={{ p: 3 }}>
              <Typography variant="h6" fontWeight={600} mb={2}>
                Project settings
              </Typography>

              {/* PROJECT MODE */}
              <Typography fontWeight={500} mb={1}>
                Project mode
              </Typography>

              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                <label>
                  <input
                    type="radio"
                    checked={projectMode === "domain"}
                    onChange={() => setProjectMode("domain")}
                  />
                  &nbsp; Domain-related project
                </label>

                <label>
                  <input
                    type="radio"
                    checked={projectMode === "nodomain"}
                    onChange={() => setProjectMode("nodomain")}
                  />
                  &nbsp; Project not related to a domain
                </label>
              </Box>

              {/* CONDITIONAL FIELD */}
              <Box mt={3}>
                {projectMode === "domain" ? (
                  <>
                    <Typography fontWeight={500} mb={1}>
                      Project homepage (full URL address) *
                    </Typography>

                    <input
                      type="text"
                      placeholder="https://example.com"
                      value={projectHomepage}
                      onChange={(e) => setProjectHomepage(e.target.value)}
                      style={{
                        width: "100%",
                        padding: "10px",
                        borderRadius: "6px",
                        border: "1px solid #ddd",
                        fontSize: "14px",
                      }}
                    />
                  </>
                ) : (
                  <>
                    <Typography fontWeight={500} mb={1}>
                      Project name
                    </Typography>

                    <input
                      type="text"
                      placeholder="Enter project name"
                      value={projectName}
                      onChange={(e) => setProjectName(e.target.value)}
                      style={{
                        width: "100%",
                        padding: "10px",
                        borderRadius: "6px",
                        border: "1px solid #ddd",
                        fontSize: "14px",
                      }}
                    />
                  </>
                )}
              </Box>

              {/* ACTIONS */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 2,
                  mt: 4,
                }}
              >
                <Button
                  variant="outlined"
                  onClick={() => setOpenSettings(false)}
                >
                  Cancel
                </Button>

                {/* <Button
                  variant="contained"
                  onClick={() => {
                    console.log("Saving settings for row:", activeRow?.id);
                    console.log({
                      projectMode,
                      projectHomepage,
                      projectName,
                    });

                    // 🔔 Later you can wire this to backend mutation
                    setOpenSettings(false);
                  }}
                >
                  Save
                </Button> */}
                {/* <Button
                  variant="contained"
                  disabled={projectMode === "domain" && !projectHomepage.trim()}
                  onClick={() => {
                    console.log("Saving settings for row:", activeRow?.id);
                    console.log({
                      projectMode,
                      projectHomepage,
                      projectName,
                    });

                    setOpenSettings(false);          // close settings dialog
                    setOpenSettingsSuccess(true);    // open success popup
                  }}
                >
                  Save
                </Button> */}
                <Button
                  variant="contained"
                  disabled={projectMode === "domain" && !projectHomepage.trim()}
                  onClick={async () => {
                    try {
                      await UPDATE_PROJECT_SETTINGS_MUTATION({
                        variables: {
                          data: {
                            queryId: activeRow.id,
                            projectMode,
                            projectHomepage,
                            projectName,
                          },
                        },
                      });

                      // 🔄 Update UI row locally
                      setContentQueries(prev =>
                        prev.map(item =>
                          item.id === activeRow.id
                            ? {
                              ...item,
                              projectMode,
                              projectHomepage,
                              projectName,
                            }
                            : item
                        )
                      );

                      setOpenSettings(false);
                      setOpenSettingsSuccess(true);
                    } catch (err) {
                      console.error(err);
                      handleOpen(true, "Failed to update project settings");
                    }
                  }}
                >
                  Save
                </Button>
              </Box>
            </Box>
          </Dialog>

          <Dialog
            open={openSettingsSuccess}
            onClose={() => setOpenSettingsSuccess(false)}
            maxWidth="xs"
            fullWidth
          >
            <Box sx={{ p: 3, textAlign: "center" }}>
              <CheckCircleIcon sx={{ fontSize: 48, color: "green" }} />

              <Typography variant="h6" fontWeight={600} sx={{ mt: 2 }}>
                Success
              </Typography>

              <Typography sx={{ mt: 1 }}>
                Project settings have been changed
              </Typography>

              <Box sx={{ mt: 3 }}>
                <Button
                  variant="contained"
                  onClick={() => setOpenSettingsSuccess(false)}
                >
                  OK
                </Button>
              </Box>
            </Box>
          </Dialog>

        </Box>
      </Container>
    </SectionWrapper>
  );
}

export default ContentScore;
